import React, { useEffect, useRef } from "react";
import { drawEgg } from "./golden-eggs";

// The shop's Golden Egg (golden-eggs.ts) at icon size, slowly turning: the
// currency's face wherever eggs are earned or shown inline. Still under
// reduced motion.
export default function GoldenEggIcon({ size = 18, className }: { size?: number; className?: string }) {
  const ref = useRef<HTMLCanvasElement | null>(null);
  useEffect(() => {
    const canvas = ref.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;
    const dpr = Math.min(3, window.devicePixelRatio || 1);
    const px = Math.round(size * 1.6); // the egg art has a glow margin around it
    canvas.width = px * dpr;
    canvas.height = px * dpr;
    ctx.scale(dpr, dpr);
    const still = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
    let raf = 0;
    const t0 = performance.now() - Math.random() * 4000; // eggs side by side turn out of step
    const frame = (now: number) => {
      ctx.clearRect(0, 0, px, px);
      drawEgg(ctx, px, still ? 1.2 : (now - t0) / 1000);
      if (!still) raf = requestAnimationFrame(frame);
    };
    raf = requestAnimationFrame(frame);
    return () => cancelAnimationFrame(raf);
  }, [size]);
  const px = Math.round(size * 1.6);
  return (
    <canvas
      ref={ref}
      className={className}
      aria-hidden="true"
      style={{ width: px, height: px, margin: -(px - size) / 2, verticalAlign: "middle", display: "inline-block" }}
    />
  );
}
